import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'baf-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  isSmallView = false;

  constructor() {
    this.setVisibility(window.innerWidth);
  }

  @HostListener('window:resize', ['$event.target'])
  onWindowResize(target) {
    this.setVisibility(target.innerWidth);
  }

  private setVisibility(width: number) {
   // this.isSmallView = width < 840;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts